import { Link, useSearchParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import SearchResults from "@/pages/blog/components/SearchResults";

export default function BlogSearch() {
  const [params] = useSearchParams();
  const query = params.get("q") ?? "";
  const clean = query.trim();

  const title = clean
    ? `Busca por "${clean}" | Blog NXHOST`
    : "Busca no blog | Blog NXHOST";
  const description = clean
    ? `Resultados de busca no Blog NXHOST para "${clean}". Conteúdos sobre hospedagem, sites, domínios, SEO, servidores e marketing digital.`
    : "Pesquise no Blog NXHOST por assuntos de tecnologia, hospedagem, criação de sites, SEO, banco de dados e marketing digital.";

  return (
    <SiteLayout>
      <Seo
        title={title}
        description={description}
        keywords="busca blog, hospedagem, criação de sites, SEO, domínios, servidores, marketing digital"
        path="/blog/busca"
        noindex
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Blog", path: "/blog" },
          { name: "Busca", path: "/blog/busca" },
        ]}
      />

      <section className="relative overflow-hidden bg-foreground-950 text-background-50">
        <div className="absolute inset-0 nx-grid opacity-30"></div>
        <div className="nx-glow absolute -top-40 right-0 h-[420px] w-[420px] animate-pulseGlow"></div>
        <div className="relative mx-auto w-full max-w-7xl px-4 pt-28 pb-12 md:px-8 md:pt-36 md:pb-14">
          <nav aria-label="Trilha de navegação" className="flex flex-wrap items-center gap-2 text-xs text-background-400">
            <Link to="/" className="transition-colors hover:text-background-50">
              Início
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <Link to="/blog" className="transition-colors hover:text-background-50">
              Blog
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-background-200">Busca</span>
          </nav>
          <h1 className="mt-5 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            {clean ? (
              <>
                Resultados para <span className="text-accent-300">&ldquo;{clean}&rdquo;</span>
              </>
            ) : (
              "Buscar no Blog NXHOST"
            )}
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            Pesquise por palavra-chave, tema ou problema técnico. Ex.: como criar banco de dados mysql, o que é DNS, configurar SSL.
          </p>
        </div>
      </section>

      <SearchResults query={clean} />
    </SiteLayout>
  );
}